const polyfilledElementMatches = Element.prototype.matches
    || Element.prototype.msMatchesSelector
    || Element.prototype.webkitMatchesSelector;
/**
 * Returns whether the given element matches the optional selector
 *
 * @internal
 */
export function elementMatches(element, selector = null) {
    return (null === selector) || polyfilledElementMatches.call(element, selector);
}
/**
 * Fetches all siblings, in the given direction.
 * Will start from the given element, traverse in the given direction and fetch the first (or all) matches
 *
 * @internal
 */
export function fetchSiblings(element, selector, accessor) {
    let sibling = element[accessor];
    const list = [];
    while (sibling) {
        if (elementMatches(sibling, selector)) {
            list.push(sibling);
        }
        sibling = sibling[accessor];
    }
    return list;
}
